// extracted by mini-css-extract-plugin
export var actionIcon = "_ua-0";